import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const RenovacionPendiente = ({ onClose }) => {
  const { API, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [estadoRenovacion, setEstadoRenovacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);

  // Roles que pueden ver este modal
  const rolesPermitidos = ['estudiante', 'graduado', 'pastor'];
  const esRolPermitido = user && rolesPermitidos.includes(user.rol);

  useEffect(() => {
    // Verificar si el usuario tiene un rol permitido
    if (esRolPermitido) {
      verificarEstado();
    } else {
      setLoading(false);
    }
  }, [user]);

  const verificarEstado = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/estudiantes/estado-renovacion`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('📊 Respuesta de renovación:', response.data);
      console.log('📊 Forzado por admin:', response.data.forzado_por_admin);
      console.log('📊 Necesita renovación:', response.data.necesita_renovacion);
      
      // Si el admin forzó, redirigir directamente SIN mostrar modal
      if (response.data.forzado_por_admin) {
        sessionStorage.removeItem('renovacion_modal_closed_temp');
        console.log('🔓 Admin forzó - redirigiendo directamente a proceso-registro');
        
        // Desactivar el flag inmediatamente para evitar loops
        try {
          await axios.put(`${API}/users/me/popup-registro`, 
            { mostrar_popup_registro: false },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          console.log('✅ Flag mostrar_popup_registro desactivado');
        } catch (error) {
          console.error('Error desactivando flag:', error);
        }
        
        // Redirigir directamente a proceso-registro
        navigate('/app/proceso-registro');
        return;
      }
      
      // Si NO fue forzado por admin, NO mostrar nada
      // El modal de selección de semestres ya no se usa
      // Los estudiantes van directamente al proceso-registro si necesitan registrarse
      console.log('ℹ️ No forzado por admin - no se muestra modal');
      setLoading(false);
      
    } catch (error) {
      console.error('Error verificando estado de renovación:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleIrAInscripcion = async (semestreId = null) => {
    console.log('🚀 Navegando al Plan B (proceso-registro)...', semestreId ? `con semestre: ${semestreId}` : '');
    setMostrarModal(false);
    if (onClose) onClose();
    
    // Marcar en sessionStorage para evitar bucle durante la navegación
    sessionStorage.setItem('renovacion_modal_closed_temp', 'true');
    
    // Guardar el semestre seleccionado en localStorage para el Plan B
    if (semestreId && estadoRenovacion?.semestres_disponibles) {
      const semestre = estadoRenovacion.semestres_disponibles.find(s => s.id === semestreId);
      if (semestre) {
        localStorage.setItem('semestreSeleccionado', JSON.stringify(semestre));
      }
    }
    
    // Desactivar el flag en el backend
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/users/me/popup-registro`, 
        { mostrar_popup_registro: false },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log('✅ Flag mostrar_popup_registro desactivado en backend');
    } catch (error) {
      console.error('Error desactivando flag:', error);
    }
    
    // Navegar al Plan B (proceso de registro por etapas)
    navigate('/app/proceso-registro');
  };

  const handleCerrarTemporal = () => {
    setMostrarModal(false);
    if (onClose) onClose();
  };

  // Este componente ya no muestra modal - solo redirecciona si el admin forzó
  // La selección de semestres se hace en /app/proceso-registro
  return null;
};

export default RenovacionPendiente;
